import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { LoadIndicator } from 'devextreme-react/load-indicator'
import axios from 'axios'
import FavoriteButton from '../favorite-button/FavoriteButton'

interface FavoriteItem {
	id: number
	user_id: number
	folder: string
	model: string
	text: string
	desc?: string
	filter?: string
	dashboard: any
	created_at: string
	updated_at: string
}

export default function Favorites() {
	const [favorites, setFavorites] = useState<FavoriteItem[]>([])
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		loadFavorites()
	}, [])

	const loadFavorites = async () => {
		try {
			setLoading(true)
			const response = await axios.get(`${API_FIBER_URL}/favorites`)
			if (response.data.success) {
				setFavorites(response.data.favorites)
			}
		} catch (error) {
			console.error('Error loading favorites:', error)
		} finally {
			setLoading(false)
		}
	}

	const removeFavorite = async (favorite: FavoriteItem) => {
		try {
			await axios.delete(`${API_FIBER_URL}/favorites/remove?folder=${favorite.folder}&model=${favorite.model}`)
			loadFavorites()
		} catch (error: any) {
			console.error('Error removing favorite:', error)
		}
	}

	const getModelUrl = (favorite: FavoriteItem) => {
		let url = favorite.dashboard === '1' ? '/dashboard' : '/m'
		url = `${url}?folder=${favorite.folder}&model=${favorite.model}`
		if (favorite.filter) {
			url = `${url}&filter=${favorite.filter}`
		}
		return url
	}

	if (loading) {
		return (
			<div className={'content-block'}>
				<LoadIndicator height={20} width={20} />
			</div>
		)
	}

	if (favorites.length === 0) {
		return null
	}

	return (
		<div className={'content-block'}>
			<h5 style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}>
				My Favorites Forms
			</h5>
			<div className={'gridView'}>
				{favorites.map(favorite => (
					<Link
						key={favorite.id}
						className="modelCard"
						to={getModelUrl(favorite)}
						style={{ position: 'relative' }}
					>
						<div className={'textWrapper'}>
							<p style={{ fontSize: '16px', marginBottom: '0' }}>{favorite.text}</p>
							{favorite.desc && <p style={{ marginTop: '2px', fontSize: '12px' }}>{favorite.desc}</p>}
							<p style={{ fontSize: '11px', color: '#666', marginTop: '8px' }}>{favorite.folder}</p>
						</div>
						<FavoriteButton
							item={{
								model: favorite.model,
								text: favorite.text,
								desc: favorite.desc,
								filter: favorite.filter,
								dashboard: favorite.dashboard,
								folder: favorite.folder,
							}}
							isFavorite={true}
							onToggle={(item, e) => {
								e?.event?.preventDefault()
								e?.event?.stopPropagation()
								removeFavorite(favorite)
							}}
						/>
					</Link>
				))}
			</div>
		</div>
	)
}
